const simplifiedPages = [
  'security-researchers-esp',
  'security-researchers-br',
  'security-researchers',
];

module.exports = simplifiedPages;
